import { Appear } from "@/components/appear";
import { useAppStore } from "@/store";
import styled from "@emotion/styled";
import { observer } from "mobx-react-lite";
import { SidebarContentsPinnedItems } from "./sidebar-contents-pinned-items";
import { SidebarContentsRecentNotes } from "./sidebar-contents-recent-notes";
import { SidebarContentsRecentCollections } from "./sidebar-contents-recent-collections";
import { MDSSidebarButton } from "@/mds/components/sidebar/sidebar-button";
import { MDSText, MDSTextVariant, MDSTextWeight, MDSButtonIcon } from "@/mds";
import { EventContext } from "@/domains/metrics/context";
import { MdsIconKind } from "@/design-system/components/icon";

export interface SidebarContentsProps {
  onClick?: () => void;
}

export const SidebarContents = observer(function SidebarContents({
  onClick,
}: SidebarContentsProps) {
  const { store } = useAppStore();
  const isFavoriteItemsReady = store.favoriteItems.isReady;
  return (
    <StyledAppear visible={isFavoriteItemsReady}>
      <MDSSidebarButton
        onClick={() => store.notes.composeNewNote({ eventContext: EventContext.GlobalActions })}
      >
        <StyledButtonIcon kind={MdsIconKind.ComposeInline} />
        <MDSText variant={MDSTextVariant.TextS} weight={MDSTextWeight.Medium}>
          Create Note
        </MDSText>
      </MDSSidebarButton>
      <ScrollablePortion>
        <SidebarContentsPinnedItems onClick={onClick} />
        <SidebarContentsRecentNotes onClick={onClick} />
        <SidebarContentsRecentCollections onClick={onClick} />
      </ScrollablePortion>
    </StyledAppear>
  );
});

const ScrollablePortion = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing["2"]};
  overflow-y: auto;
  min-height: 0;
  height: 100%;
  scrollbar-width: none;
  &::-webkit-scrollbar {
    display: none;
  }
`;
ScrollablePortion.displayName = "ScrollablePortion";

const StyledAppear = styled(Appear)`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing["2"]};
  flex: 1;
  overflow: hidden;
`;
StyledAppear.displayName = "StyledAppear";

const StyledButtonIcon = styled(MDSButtonIcon)`
  .mds-icon {
    font-size: 11px;
    height: 11px;
    width: 11px;
  }
`;
